<template>
    <div class="d-flex flex-wrap gap-2 align-items-center">
        <div class="flex-grow-1 min-w-0">
            <input
                type="date"
                class="form-control form-control-sm w-100"
                v-model="inputDate"
                :disabled="disabled"
                @change="handleDateChange"
            />
        </div>

        <div
            v-if="enableTimePicker"
            class="d-flex gap-1 align-items-center flex-grow-1 flex-sm-grow-0"
        >
            <input
                type="number"
                min="0"
                max="23"
                step="1"
                class="form-control form-control-sm text-center"
                style="max-width: 4.5rem;"
                v-model.number="hours"
                placeholder="HH"
                :disabled="disabled"
                @change="formatHours"
            />

            <span class="align-self-center">:</span>

            <input
                type="number"
                min="0"
                max="59"
                step="1"
                class="form-control form-control-sm text-center"
                style="max-width: 4.5rem;"
                v-model.number="minutes"
                placeholder="MM"
                :disabled="disabled"
                @change="formatMinutes"
            />

            <button
                v-if="setTimeButtonVisible"
                type="button"
                class="btn btn-sm btn-outline-secondary ms-1 px-2 flex-shrink-0"
                :disabled="disabled"
                @click="onSetTimeClick"
                title="Set time"
                aria-label="Set time"
            >
                <font-awesome-icon icon="clock"/>
            </button>
        </div>
    </div>
</template>

<script>

import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
export default {
    name: 'DateTimePickerCommon',
    components: {FontAwesomeIcon},
    mixins: [],
    data() {
        return {
            inputDate: null,
            hours: 0,
            minutes: 0,
            dateInputTimer: null
        }
    },
    props: {
        date: {
            type: String,
            default: null
        },
        minDate: {
            type: String,
            default: null
        },
        enableTimePicker: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        responseType: {
            type: String,
            default: 'iso' // 'iso' || 'date'
        },
        setTimeButtonVisible: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:date'],
    watch: {
        date() {
            this.initializeDate()
        }
    },
    mounted() {
        this.initializeDate()
    },
    methods: {
        handleDateChange() {
            clearTimeout(this.dateInputTimer)
            this.dateInputTimer = setTimeout(() => {
                this.handleChange()
            }, 1000) // wait 1000ms after user stops typing - we do not want to emit on each small change in month or date as many server requests are triggered by time change
        },

        initializeDate() {
            if (!this.date) {
                this.inputDate = null
                this.hours = "00"
                this.minutes = "00"
            } else {
                const d = new Date(this.date)
                // Extract local values
                const year = d.getFullYear()
                const month = String(d.getMonth() + 1).padStart(2, '0')
                const day = String(d.getDate()).padStart(2, '0')

                const hours = String(d.getHours()).padStart(2, '0')
                const minutes = String(d.getMinutes()).padStart(2, '0')

                // Set values
                this.inputDate = `${year}-${month}-${day}`
                this.hours = hours
                this.minutes = minutes
            }
        },

        formatHours() {
            setTimeout(() => {
                if (this.hours < 0 || this.hours > 23) {
                    this.hours = 0
                }

                if (this.hours < 10) {
                    this.hours = String(this.hours).padStart(2, '0')
                }

                this.handleChange()
            }, 500);
        },

        formatMinutes() {
            setTimeout(() => {
                if (this.minutes < 0 || this.minutes > 59) {
                    this.minutes = 0
                }
                if (this.minutes < 10) {
                    this.minutes = String(this.minutes).padStart(2, '0')
                }

                this.handleChange()
            }, 500)
        },

        handleChange() {
            if (!this.inputDate) return null
            const d = new Date(this.inputDate)
            d.setHours(Number(this.hours), Number(this.minutes), 0, 0)
            this.$emit('update:date', this.responseType === 'date' ? this.inputDate : d.toISOString())
        },

        reset() {
            this.inputDate = null
            this.hours = 0
            this.minutes = 0
            this.formatMinutes()
            this.formatHours()
        },

        onSetTimeClick() {
            const d = new Date()
            // Extract local values
            const year = d.getFullYear()
            const month = String(d.getMonth() + 1).padStart(2, '0')
            const day = String(d.getDate()).padStart(2, '0')

            const hours = String(d.getHours()).padStart(2, '0')
            const minutes = String(d.getMinutes()).padStart(2, '0')

            // Set values
            this.inputDate = `${year}-${month}-${day}`
            this.hours = hours
            this.minutes = minutes

            this.$emit('update:date', this.responseType === 'date' ? date : d.toISOString())
        }

    }
}
</script>
<style>
:root {
    --dp-font-size: .8rem !important; /*Default font-size*/
    --dp-preview-font-size: 0.8rem; /*Font size of the date preview in the action row*/
    --dp-time-font-size: 0.8rem; /*Font size in the time picker*/
}
</style>
